var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGround(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "32.074px",
    height: "32.074px",
    viewBox: "0 0 32.074 32.074",
    style: {
      enableBackground: "new 0 0 32.074 32.074"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.265,12.053c-1.962,0-3.576,1.551-3.742,3.431h7.482C19.839,13.604,18.226,12.053,16.265,12.053z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.061,
    width: 10.948,
    height: 1.99
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.265,20.672c-2.394,0-4.379-1.869-4.708-4.082H3.317v14.07c0,0.781,0.633,1.414,1.414,1.414h5.333v-2.52 c0-0.277,0.189-0.467,0.466-0.467h12.016c0.275,0,0.459,0.188,0.459,0.467v2.52h4.531c0.674,0,1.221-0.547,1.221-1.223V16.59 h-7.782C20.643,18.803,18.657,20.672,16.265,20.672z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.005,0v2.52c0,0.277-0.187,0.466-0.461,0.466H10.53c-0.277,0-0.466-0.189-0.466-0.466V0H4.748 c-0.79,0-1.43,0.64-1.43,1.43v14.054h8.201c0.168-2.433,2.231-4.432,4.746-4.432c2.514,0,4.576,1.999,4.744,4.432h7.748V1.222 C28.757,0.547,28.21,0,27.534,0H23.005z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.265,19.67c1.84,0,3.373-1.421,3.693-3.08h-7.391C12.89,18.249,14.424,19.67,16.265,19.67z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.061,
    y: 30.084,
    width: 10.948,
    height: 1.99
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGround);
export default __webpack_public_path__ + "static/media/ground.61c4a7466653cdd9f1efb6ed6c76e558.svg";
export { ForwardRef as ReactComponent };